'use client';

import dynamic from 'next/dynamic';
import CardLocation from '@alltrails/amplitude/enums/CardLocation';
import MapLocation from '@alltrails/amplitude/enums/MapLocation';
import TrailCardLocation from '@alltrails/amplitude/enums/TrailCardLocation';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import type { TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import MapProvider from '../MapProvider/MapProvider';
import styles from './TrailListMap.module.scss';

export const LoadingMap = () => (
  <div className={styles.mapContainer}>
    <ShimmerContainer className={styles.shimmerContainer}>
      <div />
    </ShimmerContainer>
  </div>
);

const TrailListMap = dynamic(() => import('./TrailListMap'), {
  ssr: false,
  loading: LoadingMap
});

type DynamicTrailListMapProps = {
  isLoading?: boolean;
  trailSearchResults: TrailSearchResult[];
  exploreLink?: string;
  mapLocation?: MapLocation | string; // Accept string for legacy PageStrings support
  cardLocation?: TrailCardLocation;
  detailedCardLocation?: CardLocation;
  onExpandMap?: () => void;
  isExpanded?: boolean;
  preventClustering?: boolean;
};

const DynamicTrailListMap = ({
  isLoading,
  trailSearchResults,
  exploreLink,
  mapLocation,
  cardLocation,
  detailedCardLocation,
  onExpandMap,
  isExpanded,
  preventClustering
}: DynamicTrailListMapProps) => {
  if (isLoading) {
    return <LoadingMap />;
  }

  return (
    <MapProvider>
      <TrailListMap
        trailSearchResults={trailSearchResults}
        exploreLink={exploreLink}
        mapLocation={mapLocation}
        cardLocation={cardLocation}
        detailedCardLocation={detailedCardLocation}
        onExpandMap={onExpandMap}
        isExpanded={isExpanded}
        preventClustering={preventClustering}
      />
    </MapProvider>
  );
};

export default DynamicTrailListMap;
